<template>
    <div :class="chartClass">
      <apexchart
        type="donut"
        :options="chartOptions"
        :series="series"
        @dataPointSelection="handleDataPointSelection"
      ></apexchart>
    </div>
  </template>
  
  <script>
  import VueApexCharts from 'vue-apexcharts'
  
  export default {
    components: {
      apexchart: VueApexCharts,
    },
    props: {
      entregados: {
        type: Number,
        required: true,
      },
      con_absentismos: {
        type: Number,
        required: true,
      },
      sin_absentismos: {
        type: Number,
        required: false,
        deafult: 0,
      },
      titulo: {
        type: String,
        required: true,
      },
      tooltipText: {
        type: String,
        required: true,
      },
      chartClass: {
        type: String,
        default: ''
      },
      labels: {
        type: Array,
        required: true,
      }
    },
    computed: {
      series() {
      const series = [this.entregados, this.con_absentismos]
      if (this.sin_absentismos !== 0) {
        series.push(this.sin_absentismos)
      }
      return series
    },
      chartOptions() {
        return {
          labels: this.labels,
          //un verde y 2 rojos de diferenten tonos
          colors: ['#00b74a', '#ff4d4f', '#ff7a45'],
          tooltip: {
        y: {
          formatter: (val) => `${val} ${this.tooltipText}`
        }
          },
          chart: {
        events: {
          dataPointSelection: this.handleDataPointSelection
        }
          },
          plotOptions: {
        pie: {
          donut: {
            labels: {
          show: true,
          total: {
            show: true,
            showAlways: true,
            label: this.titulo,
            fontSize: '18px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            color: '#373d3f',
          }
            }
          }
        }
          },
          legend: {
        fontSize: '18px', // Tamaño de fuente de los labels de la leyenda
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontWeight: 500,
        position: 'bottom',
        labels: {
          colors: ['#373d3f'],
          useSeriesColors: false
        }
          }
        }
      }
    },
    methods: {
      handleDataPointSelection(event, chartContext, config) {
        if (config.dataPointIndex === 1) { // Índice 1 corresponde a "No Entregados"
          this.$emit('ver-detalles')
        }
      }
    }
  }
  </script>
  
  <style>
  .small-chart {
    width: 45%; /* Reduce el ancho para que quepan dos gráficos en la misma fila */
    height: auto; /* Mantén la proporción del gráfico */
  }
  .large-chart {
    width: 80%;
    height: auto;
  }

  .large-chart-dashboard{
    width: 45%;
    height: auto;
  }
  </style>ß